let serialPort = null;
// #ifdef APP
import { RS232Serial } from '@/uni_modules/shmily-rs232-serial';
serialPort = new RS232Serial();
// #endif
const statePortInfo = {
    port: ''
};

export const getPortList = async () => {
    if (window?.electronAPI) {
        const list = (await window.electronAPI.getSerialPort?.()) || [];
        let responseList = [];
        for (let i = 0; i < list.length; i++) {
            await sendHeartBeats(list[i]);
        }
        window?.electronAPI.portMessageMain((e, msg) => {
            responseList.push(msg);
        });
        return new Promise((resolve) => {
            setTimeout(() => {
                return resolve({ list, responseList });
            }, 200);
        });
    } else {
        const list = serialPort?.getDeviceList() || [];
        let responseList = [];
        const callbackList = list.filter((e) => e.includes('USB'));
        for (let i = 0; i < callbackList.length; i++) {
            const result = await sendHeartBeats(list[i]);
            if (result.data) {
                responseList.push(result);
            }
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                return resolve({ list: callbackList, responseList });
            }, 200);
        });
    }
};

export const action_Light = async (params) => {
    try {
        const { port, open, number, baudRate = 9600, dataBits = 8, stopBits = 1, parity = 0, flowCon = 0 } = params;

        const numberString = number.toString().padStart(2, '0');
        const command = '#' + numberString + (open ? 'O$' : 'C$');

        await openPort(params);

        //exe发送
        if (window?.electronAPI) {
            const result = await window.electronAPI?.sendText({ port, command });
            // if (!result) {
            //     statePortInfo.set(port, false);
            // }
            return result;
        }

        // 以下是APP

        console.log('发送灯控数据');
        if (serialPort?.isOpen()) {
            serialPort?.sendText(command);
            return true;
        } else {
            return false;
        }
    } catch (error) {
        console.error(error);
        return false;
    }
};
export const openPort = async (params) => {
    if (window?.electronAPI) {
        const result = await window.electronAPI?.openSerialPort({
            port: params.port // 填写实际值
        });
        if (result) {
            // statePortInfo.set(params.port, result);
        } else {
            // setTimeout(() => {
            //     uni.$emit('showToast', {
            //         title: '串口打开失败',
            //         type: 'none',
            //         duration: 1000
            //     });
            // }, 2000);
        }

        return;
    }

    try {
        let result = false;
        if (serialPort) {
            if (params.port != statePortInfo.port) {
                serialPort.unsubscribe();
                serialPort?.close();
            }
            console.log('打开串口');
            result = serialPort.open({
                port: params.port, // 填写实际值
                baudRate: 9600, // 填写实际值
                // 以下参数没有时就按照下面的传
                dataBits: 8,
                stopBits: 1,
                parity: 0,
                flowCon: 0
            });
            if (result) {
                console.log('串口打开成功');
                statePortInfo.port = params.port;
            } else {
                statePortInfo.port = '';
                console.log('串口打开失败');
                setTimeout(() => {
                    uni.$emit('showToast', {
                        title: '串口打开失败',
                        type: 'none',
                        duration: 1000
                    });
                }, 2000);
            }
            return new Promise((resolve) => resolve(result));
        }
        return result;
    } catch (error) {
        console.error(error);
        // setTimeout(() => {
        //     uni.$emit('showToast', {
        //         title: '串口打开失败',
        //         type: 'none',
        //         duration: 1000
        //     });
        // }, 2000);
    }
};
export const sendHeartBeats = async (port) => {
    await openPort({ port });
    if (window && window?.electronAPI) {
        return await window?.electronAPI.sendHeartBeat({ port });
    }

    let result = '';
    let info = {
        port: port,
        data: ''
    };
    serialPort.subscribe('ASCII', (data) => {
        console.log('收到消息', data);

        result += data;
        console.log('累加', result);
        if (result.includes('$')) {
            info.data = result;
            result = '';
        }
    });
    serialPort?.sendText('#LingXing$');

    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(info);
        }, 500);
    });
};
